import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { getSentryConfig } from '@config';

export const init = () => {
  const config = getSentryConfig();
  Sentry.init({
    dsn: config.dsn,
    release: config.release,
    environment: config.environment,
    tracesSampleRate: config.tracesSampleRate,
    integrations: [new BrowserTracing()],
  });
};

export const setUserId = (id) => {
  Sentry.setUser({ id });
};

export const setContext = (context = {}) => {
  Sentry.setContext('context', context);
};

const send = (level, event, context = null) => {
  const options = { level };
  if (context) options.contexts = context;
  Sentry.captureMessage(event, options);
};

export const info = (event, context = null) => send('info', event, context);

export const warn = (event, context = null) => send('warning', event, context);

export const error = (event, context = null) => send('error', event, context);
